import { render, staticRenderFns } from "./zoomControl.template.vue?vue&type=template&id=458eca5b&scoped=true&"
var script = {}
import style0 from "./zoomControl.template.vue?vue&type=style&index=0&id=458eca5b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458eca5b",
  null
  
)

export default component.exports